// import $ from 'jquery';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import flexibility from 'flexibility';
import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import isMobile from './modules/common/is-mobile.js';
import './modules/common/smoothScroll.js';
import './modules/common/lazyload.js';
import './modules/common/userAgent.js';
import './modules/common/sp-menu.js';
import './modules/common/datepicker.js';
import './modules/common/tablefix.js';
import './modules/common/accordion.js';
import './modules/top/confetti.js';
import './modules/top/animation.js';
import './modules/top/scrollbar.js';

flexibility(document.documentElement);//flexboxのie対応
objectFitImages();//object-fitのie対応
svg4everybody();//svgをieで表示

//電話番号スマホのみ掛ける
$("a[href*='tel']").on("click", function(e){
  if(!isMobile(768)){
    return false
  }
});

//スマホで画面の高さ取得・設定
$(window).on('resize', function(){
  if(isMobile(778)) {
    $('.top-hero').css({
      'height': $(window).height()
    });
  } else {
    $('.top-hero').removeAttr('style');
  }
}).trigger('resize');
// const hoge = val => val + 1;
// console.log(hoge(1));

//サービス導入を記念して...のクリップパス
$(window).on("resize", function(){

  var point = $("#l-contents").width() * 0.32;
  $(".l-section__bg.-other").css({
    "-webkit-clip-path": "polygon(0% " + point + "px, 100% 0%, 100% 100%, 0% 100%)"
  })
}).trigger("resize");

// console.log(point);
